import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import routes from "../../../constants/routes";
import PopupChangeTheme from "./PopupChangeTheme";
import { useSelector, useDispatch } from "react-redux";
import { setLanguage } from "../../../redux/language";
import { setPopupMessage } from "../../../redux/popupMessage";
import { logout } from "../../../redux/account";

const Header = () => {
    const dispatch = useDispatch();
    const [openPopupChangeTheme, setOpenPopupChangeTheme] = useState(false);
    const { t, i18n } = useTranslation();
    const { language } = useSelector((state) => state?.language);
    const { account } = useSelector((state) => state?.account);

    useEffect(() => {
        i18n.changeLanguage(language);
    }, [language, i18n]);

    const handleChangeLanguage = (value) => {
        dispatch(setLanguage(value));
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(account?.address);
    };

    return (
        <div className="components-header">
            <div
                className="icon"
                onClick={() => setOpenPopupChangeTheme((prev) => !prev)}
            >
                <img src="/images/header1.svg" alt="" />
            </div>
            <div className="icon">
                <img src="/images/header2.svg" alt="" />
                <div className="dropdown">
                    <div className="title">{t("header.Languages")}</div>
                    <div className="items">
                        <div
                            className={`item ${
                                language === "en" ? "active" : ""
                            }`}
                            onClick={() => handleChangeLanguage("en")}
                        >
                            <div className="radio">
                                <span></span>
                            </div>
                            English
                        </div>
                        <div
                            className={`item ${
                                language === "vi" ? "active" : ""
                            }`}
                            onClick={() => handleChangeLanguage("vi")}
                        >
                            <div className="radio">
                                <span></span>
                            </div>
                            Tiếng việt
                        </div>
                    </div>
                </div>
            </div>
            {account ? (
                <>
                    <a className="connect g-buttonHover" onClick={handleCopy}>
                        <img src="/images/header3.svg" alt="" />{" "}
                        {account?.address?.slice(0, 6)}...
                        {account?.address?.slice(-6)}
                        <div className="tooltip">Copy</div>
                    </a>
                    <a
                        className="connect g-buttonHover"
                        onClick={() => dispatch(logout())}
                    >
                        {t("header.Logout")}
                    </a>
                </>
            ) : (
                <>
                    <Link to={routes.connect} className="connect g-buttonHover">
                        {t("header.Connect")}
                    </Link>
                </>
            )}

            <PopupChangeTheme
                openPopupChangeTheme={openPopupChangeTheme}
                setOpenPopupChangeTheme={setOpenPopupChangeTheme}
            />
        </div>
    );
};

export default Header;
